export default __webpack_public_path__ + "static/media/user-color-icon.a2e93705.svg";